import { CircularProgress, Button } from "@mui/material";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import * as yup from "yup";
import LoginLayoutWrapper from "../commons/layout/LogginLayoutWrapper";
import { StyledLogin } from "../styled/Login";
import { useNavigate } from "react-router-dom";

const validationSchema = yup.object({
  username: yup
    .string()
    .max(100, "El campo no puede superar los 100 caracteres")
    .required("Campo obligatorio"),
});

const initialValues = {
  username: "",
};

const RecuperarClave = ({ handleSubmit }) => {
  const loading = useSelector((state) => state.auth.recoverPassword?.loading);
  const navigate = useNavigate();

  return (
    <LoginLayoutWrapper>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        <StyledLogin.Form>
          <div>
            <StyledLogin.TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Usuario"
              name="username"
              autoFocus
              type="text"
            />
          </div>
          <StyledLogin.Button
            color="primary"
            variant="contained"
            fullWidth
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} thickness={4} color="primary" />
            ) : (
              "Recuperar Contraseña"
            )}
          </StyledLogin.Button>
          <Button
            color="primary"
            variant="outlined"
            fullWidth
            onClick={() => navigate(-1)}
            disabled={loading}
            style={{ marginTop: '10px' }}
          >
            Volver atrás
          </Button>
        </StyledLogin.Form>
      </Formik>
    </LoginLayoutWrapper>
  );
};

export default RecuperarClave;
